// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__17ssD","Email":"Contact_Email__19HOu"};